<template>
    <card title="Account Status">
        <template v-slot:right-heading>
            <badge :type="teamData.status === 'active' ? 'success' : 'warning'">
                {{ teamData.status.toLocaleUpperCase() }}
            </badge>
        </template>
        <div class="row">
            <div
                :class="{
                    'col-md-9': impersonator,
                    'col-md-12': !impersonator
                }"
            >
                <template v-if="teamData.status === 'closed'">
                    This Account is permanently Closed. Further usage will require a new Account.
                </template>
                <template v-else>
                    <template v-if="impersonator">
                        <template v-if="teamData.status === 'active'">
                            This Account has been successfully activated.
                        </template>
                        <template v-else-if="teamData.status === 'suspended'">
                            Activate the Account if Suspension reasons have been rectified.
                        </template>
                        <template v-else>
                            Activate the Account for the first time once the Subscription and Payment Method are validated.
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="teamData.status === 'active'">
                            Your account is Active, all capabilities are ready to be used.
                        </template>
                        <template v-else-if="teamData.status === 'suspended'">
                            Your Account is in Suspended status, please contact your Account Administrator to rectify the account situation.
                        </template>
                        <template v-else>
                            Your Account is in pending status, our team needs to validate your plan and payment method to proceed.
                        </template>
                    </template>
                </template>
            </div>
            <div class="col-md-3 text-right" v-if="impersonator && teamData.status !== 'closed'">
                <dropdown-actions label="Actions">
                    <template v-for="status in statusActions" :key="status.type">
                        <button
                            class="c-dropdown__item dropdown-item"
                            :data-test="status.type"
                            type="button"
                            @click.prevent="status.method"
                        >
                            {{ status.name }}
                        </button>
                    </template>
                </dropdown-actions>
            </div>
        </div>

        <kiosk-team-suspend-modal v-model:visible="modalSuspendConfirmVisible" v-model:team="teamData"></kiosk-team-suspend-modal>
    </card>
</template>

<script>
import Card from '../../general/Card.vue';
import DropdownActions from '../../general/DropDownActions.vue';
import Badge from '../../general/Badge.vue';
import adminTeamsClient from '~/services/adminTeamsClient';
import { VxSwal } from '@voxie/frontend-components';
import KioskTeamSuspendModal from '~/components/kiosk/kiosk-teams/KioskTeamSuspendModal.vue';
import { throwSwalRequestError } from '~/utils/request';

export default {
    components: {
        KioskTeamSuspendModal,
        Card,
        DropdownActions,
        Badge,
    },
    props: {
        team: {
            required: true
        },
        impersonator: {
            default: false
        }
    },
    data() {
        return {
            teamData: { ...this.team, status: this.team.status || 'pending' },
            modalActivateConfirmVisible: false,
            modalSuspendConfirmVisible: false,
        }
    },
    computed: {
        statusActions() {
            switch (this.teamData.status) {
                case 'suspended':
                case 'pending':
                    return [{ type: 'active', name: 'Activate', method: this.showModalActivateConfirm }]
                case 'active':
                    return [{ type: 'suspended', name: 'Suspend', method: this.showModalSuspendConfirm }]
                default:
                    return []
            }
        }
    },
    methods: {
        showModalSuspendConfirm() {
            this.modalSuspendConfirmVisible = true;
        },
        showModalActivateConfirm() {
            const title = this.teamData.status === 'suspended' ? 'Warning!' : 'Are you sure you want to proceed?';
            let html = '';

            if (this.teamData.status === 'suspended') {
                html = '<div class="vx-flex vx-flex-col vx-text-left vx-gap-3">' +
                    '   <p>Are you sure you want to proceed? By Activating this Account, the following will happen:</p>' +
                    '   <ul class="vx-flex vx-flex-col vx-gap-2 vx-list-disc vx-pl-4">' +
                    '       <li>All current Owners and Members will recover their respective roles privileges.</li>' +
                    '       <li>All automated messaging capabilities will be resumed.</li>' +
                    '       <li>Notice: Messages scheduled to be sent during the suspended period are already discarded</li>' +
                    '   </ul>' +
                    '</div>';
            }

            VxSwal.fire({
                icon: 'warning',
                title: title,
                html: html,
                showCancelButton: true,
                preConfirm: () => adminTeamsClient.activateTeam(this.team.id)
                    .then(() => this.teamData.status = 'active')
                    .catch(throwSwalRequestError)
            });
        },
    }
};
</script>
